import * as jQuery from 'jquery';
import { Analytics } from '@plaudit/analytics';
import 'jquery-colorbox';


const colorboxDefaults = {
	transition: 'fade',
	fixed: true,

	opacity: .9,
	scalePhotos: true,
	maxWidth: '90%',
	maxHeight: '90%',
	initialWidth: 500,
	initialHeight: 300,
	scrolling: false,
	next: '',
	previous: '',
	rel: 'collection',
	close: '<span>Close</span>'
};

export default class Collection {
	constructor() {
		const selector_component = '.collection';
		const selector_targets = '.collection__items a';
		jQuery(selector_targets).colorbox(colorboxDefaults);

		// const analytics = Analytics.getInstance();
		// const trackControlEvent = (label: string) => analytics.trackEvent('Image Collection', 'Control Click', label);
	}

}
